import { Sidebar, SidebarItem, Link, sidebarConfig, SidebarGroup, SidebarDivider, SidebarScrollWrapper, SidebarSpace, useSidebarOpenState, ChatIcon } from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { css } from '@emotion/css';
import Logo from '../../components/Root/Logo';
import SearchIcon from '@mui/icons-material/Search';
import MenuIcon from '@mui/icons-material/Menu';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { appTranslationRef } from '../../translations/app/app';

const useSidebarLogoStyles = () => {
  return {
    root: css({
      width: '100%',
      height: 3 * sidebarConfig.logoHeight,
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: -14,
    }),
    link: css({
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    })
  }
};
const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();

  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        <div style={{ transform: isOpen ? 'scale(1.5)' : 'scale(1)', transition: 'transform 0.3s' }}>
          <Logo />
        </div>
      </Link>
    </div>
  );

};

export const SidebarContent: any = NavContentBlueprint.make({
    params: {
        component: ({ navItems }) => {
            const { t } = useTranslationRef(appTranslationRef);
            console.log(navItems);
            // Create dynamic nav items from registered plugins
            const nav = navItems.withComponent(item => (
                <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
            ));

            return (
                <Sidebar>
                    <SidebarLogo />
                    <SidebarGroup label={t('rootPage.sidebar.searchLabel')} icon={<SearchIcon />} to="/search">
                        <SidebarSearchModal />
                    </SidebarGroup>
                    <SidebarDivider />
                    <SidebarGroup label={t('rootPage.sidebar.menuLabel')} icon={<MenuIcon />}>
                        {/* Core navigation items */}
                        {nav.take('page:custom-home')}
                        {/* Plugin-registered items */}
                        {nav.take('page:catalog')}
                        {nav.take('page:registry')}
                        {nav.take('page:scaffolder')}
                        {nav.take('page:api-docs')}
                        {nav.take('page:techdocs')} 
                        <SidebarItem icon={ChatIcon} to="/aws-genai/general" text="Chat Assistant" />
                        <SidebarDivider />
                        <SidebarScrollWrapper>
                            {nav.take('page:tech-radar')}
                        </SidebarScrollWrapper>
                    </SidebarGroup>
                    <SidebarSpace />
                    <SidebarDivider />
                    <SidebarGroup
                        label={t('rootPage.sidebar.settingsLabel')}
                        icon={<UserSettingsSignInAvatar />}
                    >
                        {nav.take('page:rbac')}
                        {nav.take('page:user-settings')}
                    </SidebarGroup>
                </Sidebar>
            );
        },
    },
});
